<template>
	<div class="sidebar-tbf" v-if="$auth.ready() && $auth.check()">
        <div class="fe-btn-translation p-absolute" @click="$root.$emit('open_modal_translation', 'Navbar', arrayTranslations)" v-if="globalTranslate">OPEN TRANS...</div>

		<div class="logo-tbfdigital" @mouseover="logoAnim" @click="goToGame">
			<lottie class="bird-logo active" :options="defaultOptionsLogo" :height="59" :width="48" v-on:animCreated="handleAnimationLogo"/>
		</div>
		<div class="main-menu">
			<div class="item-menu">
				<router-link :to="{name: 'dashboard', params: { slug: $auth.user().slug} }" v-bind:class="{active: $route.name == 'homepage'}" :title="$t('menu.dashboard')">
					<div class="border-left-active"></div>
					<img src="/build/icons/daily-plan.svg" class="inactive-icon">
					<img src="/build/icons/daily-plan-red.svg" class="active-icon">
				</router-link>
			</div>
			<div class="item-menu">
				<router-link :to="{name: 'master-goals' }" v-bind:class="{active: $route.name == 'show-master-goal'}" :title="$t('menu.goals')">
					<div class="border-left-active"></div>
					<img src="/build/icons/master-goals.svg" class="inactive-icon">
					<img src="/build/icons/master-goals-red.svg" class="active-icon">
				</router-link>
			</div>
			<div class="item-menu">
				<router-link :to="{name: 'objectives' }" v-bind:class="{active: $route.name == 'show-objective'}" :title="$t('menu.objectives')">
					<div class="border-left-active"></div>
					<img src="/build/icons/objectives.svg" class="inactive-icon">
					<img src="/build/icons/objectives-red.svg" class="active-icon">
				</router-link>
			</div>
			<div class="item-menu">
				<router-link :to="{name: 'users' }" v-bind:class="{active: $route.name == 'show-user'}" :title="$t('menu.people')">
					<div class="border-left-active"></div>
					<img src="/build/icons/people.svg" class="inactive-icon">
					<img src="/build/icons/people-red.svg" class="active-icon">
				</router-link>
			</div>
			<div class="item-menu" v-if="$auth.user().rights.view_reports">
				<router-link :to="{name: 'reports' }" v-bind:class="{active: $route.name == 'reports'}" :title="$t('menu.reports')">
					<div class="border-left-active"></div>
					<img src="/build/icons/reports.svg" class="inactive-icon">
					<img src="/build/icons/reports-red.svg" class="active-icon">
				</router-link>
			</div>
		</div>
		<div class="logout-sidebar">
			<div class="logout-action" @click="logout"><icon-logout /></div>
		</div>
	</div>
</template>

<script>
	import Lottie from 'vue-lottie';
	import * as animationDataLogo from '../Animations/tbfdigital_logo.json';
	import IconLogout from '../Icons/Logout'
	export default {
		data() {
			return {
				defaultOptionsLogo: {
					animationData: animationDataLogo.default,
					autoplay: false,
					loop: false,
				},
				finished: true,
				bird_noti: false,
				arrayTranslations: [
					'menu.dashboard',
					'menu.goals',
					'menu.objectives',
					'menu.people',
					'menu.reports'
				]
			};
		},
		components: {
			Lottie,
			IconLogout
		},
		watch: {
		},
		mounted() {

		},
		methods: {
			handleAnimationLogo(anim){
				this.anim_logo = anim;
				this.anim_logo.setSpeed(1);
			},
			logoAnim(){
				if(this.finished && !this.bird_noti){
					this.finished = false;
					this.anim_logo.play();
					setTimeout(() => {
						this.anim_logo.stop();
						this.finished = true;
					}, 5000);
				}
			},
			logout(){
				this.$auth.logout();
			},
			goToGame(){
				this.$router.push({ name: 'game'})
			}
		},
		computed:{}
	};
</script>